//This set to use Production Mode or DevelopmentMode
export const IsProdMode = false;

export const IsTestMode = true;

export const IsEncryption = true;

export const IsQueryParamsEncryption = true;

export const IsCookieEncryption = true;
